export default __webpack_public_path__ + "static/media/stanford_logo.de5f29de.png";